export default "__VITE_ASSET__Dxdio9Wq__"